// extracted by mini-css-extract-plugin
export var dataCell = "_qe-2";
export var dataRow = "_qe-0";
export var headerRow = "_qe-1";